import { PRIMARY } from '../styles';
export default {
  body: {
    margin: 10,
  },
  row: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 10,
    width: 280,
  },
  baseCharge: {
    flex: 1,
  },
  costEstimator: {
    padding: 20,
  },
  slider: {
    flex: 1,
  },
  cost: {
    textAlign: 'right',
    fontSize: 36,
    color: PRIMARY,
  },
  count: {
    textAlign: 'right',
    fontSize: 24,
    color: PRIMARY,
  },
  retentionPeriod: {
    textAlign: 'right',
    fontSize: 24,
    color: PRIMARY,
  },
  retentionPeriodCost: {
    textAlign: 'right',
    fontSize: 36,
    color: PRIMARY,
  },
  brandedApp: {
    flex: 1,
    fontSize: '1.17em',
    fontWeight: 'bold',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  brandedAppCost: {
    textAlign: 'right',
    fontSize: 36,
    color: PRIMARY,
  },
};



// WEBPACK FOOTER //
// ./src/components/UpgradeDialog/styles.js